import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../../environments/environment';

// Conectado a Socket.io real (2026-08-31) — el backend (socket.server.js) ya autentica con el
// mismo JWT que el HTTP y arma rooms `user_<id>` / `business_<id>` / `conv_<id>` (ver
// socket.handlers.js). Un solo socket por sesión de navegador, abierto en AppShellComponent
// (se monta una sola vez, detrás de authGuard) y cerrado en su ngOnDestroy.
@Injectable({ providedIn: 'root' })
export class SocketService {
  private socket: Socket | null = null;

  connect(token: string): void {
    if (this.socket?.connected) return;
    this.socket = io(environment.socketUrl, {
      auth: { token },
      withCredentials: true,
      transports: ['websocket', 'polling'],
    });
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
  }

  on<T>(event: string, callback: (payload: T) => void): void {
    this.socket?.on(event, callback);
  }

  off(event: string): void {
    this.socket?.off(event);
  }

  emit<T>(event: string, payload: T): void {
    this.socket?.emit(event, payload);
  }

  joinBusiness(businessId: string): void {
    this.emit('join_business', { businessId });
  }

  joinConversation(conversationId: string): void {
    this.emit('join_conversation', { conversationId });
  }

  leaveConversation(conversationId: string): void {
    this.emit('leave_conversation', { conversationId });
  }
}
